import { createSelector } from 'reselect';

export const selectCodePanel = (state) => state.CodePanel;
export const selectContent = createSelector(selectCodePanel, (CodePanel) => CodePanel.content);
export const selectUpdateLocalContent = createSelector(
  selectCodePanel,
  (CodePanel) => CodePanel.updateLocalContent,
);
export const selectInsertedOperationCode = createSelector(
  selectCodePanel,
  (CodePanel) => CodePanel.insertedOperationCode,
);
export const selectInsertLocation = createSelector(
  selectCodePanel,
  (CodePanel) => CodePanel.insertLocation,
);
